import { render } from "./LavadosTable.vue?vue&type=template&id=6c4403b1"
import script from "./LavadosTable.vue?vue&type=script&lang=js"
export * from "./LavadosTable.vue?vue&type=script&lang=js"

import "./LavadosTable.vue?vue&type=style&index=0&id=6c4403b1&lang=css"

import exportComponent from "C:\\repos\\excurix\\src\\UI\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__